import { useTypedTranslation } from '~/shared/hooks';

const DataError = () => {
  const t = useTypedTranslation(['text']);

  return <div>{t('text.error')}</div>;
};

export default DataError;
